import { AccountJwt, Conf2SpecialJwt } from "@common/domain";
import { getSelectors, RouterReducerState } from "@ngrx/router-store";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AccountEntity } from "@youm-front/account/domain";
import { ACCOUNT_FEATURE_KEY, AccountState } from "../reducers";

const selectRouter = createFeatureSelector<RouterReducerState>("router");
const { selectQueryParams } = getSelectors(selectRouter);

const accountState = createFeatureSelector<AccountState>(ACCOUNT_FEATURE_KEY);

export const isLoading = createSelector(accountState, (state: AccountState) => {
  return state.isLoading;
});

export const conf2SignInFailure = createSelector(
  accountState,
  (state: AccountState) => state.conf2SignInFailure
);

export const account = createSelector(accountState, (state: AccountState) => {
  return state.account ? new AccountEntity(state.account) : null;
});

export const conf2SpecialJwt = createSelector(selectQueryParams, (_) => {
  return _?.["jwt"] as undefined | Conf2SpecialJwt;
});

export const token = createSelector(selectQueryParams, (_) => {
  return _?.["token"] as undefined | AccountJwt;
});
